module.exports = __webpack_public_path__ + "static/media/1on1-active.2d18c38b.svg";